import React from 'react';
import { Menu } from 'antd';
import { MilitaryZoneDto, MilitaryZoneDto_MilitaryZoneActivation } from 'app/model/SOL49';
import { Flex } from 'app/components/common/Flex';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';
import FlightLevelUtils from 'app/common/util/FlightLevelUtils';
import { ObjectTypeContextMenu } from 'app/components/dashboard/network/flows/menu/MapContextMenu';

interface MapMilitaryZoneContextMenuProps extends ObjectTypeContextMenu {
    militaryZones: Array<MilitaryZoneDto>;
}

export class MapMilitaryZoneContextMenu extends React.PureComponent<MapMilitaryZoneContextMenuProps> {
    render() {
        const menuItems = this.props.militaryZones.map(mz => {
            return {
                key: mz.airspaceId,
                label: mz.airspaceId,
                children: [...this.renderActivations(mz.airspaceId, mz.activations)],
            };
        });

        const menu = [
            {
                key: 'military',
                label: <span className="detailed-subpanel-title">Military ({menuItems.length})</span>,
                children: menuItems,
            },
        ];

        return <Menu items={this.props.group ? menu : menuItems} triggerSubMenuAction="click" />;
    }

    private renderActivations(airspaceId: string, activations: Array<MilitaryZoneDto_MilitaryZoneActivation>) {
        if (activations) {
            return activations.map(activation => {
                return {
                    label: this.renderActivation(airspaceId, activation),
                    key: `menu-key-${airspaceId}-${FlightLevelUtils.toFlightLevelBandString(activation.flightLevelBand)}-${TimePeriodUtils.formatHHMM(activation.timePeriod)}`,
                    className: 'menuItemConvection',
                };
            });
        }
        return [];
    }

    renderActivation(airspaceId: string, activation: MilitaryZoneDto_MilitaryZoneActivation) {
        return (
            <Flex
                direction="vertical"
                style={{
                    borderBottom: '1px solid white',
                    marginBottom: '3px',
                    margin: '1.5em',
                    width: '16em',
                }}
                key={`label-${airspaceId}-${FlightLevelUtils.toFlightLevelBandString(activation.flightLevelBand)}-${TimePeriodUtils.formatHHMM(activation.timePeriod)}`}>
                <p style={{ color: 'white' }}>
                    <span style={{ float: 'left' }}>
                        {FlightLevelUtils.toFlightLevelBandString(activation.flightLevelBand)}
                    </span>
                    <span style={{ float: 'right' }}>{TimePeriodUtils.formatDDHHMM(activation.timePeriod)}</span>
                </p>
            </Flex>
        );
    }
}
